import {createContext} from 'react'

const CatLaboratoriosContext = createContext()

export default CatLaboratoriosContext